<div class="table-outer-wrapper">
  <!-- Resource Summary -->
  <app-planning-draft-resources-table-list-item [resource]="resource"
                                                [settings]="settings"
                                                [resourceRoutes]="sortedRoutes ?? []"
                                                [itemElementSize]="itemElementSize"
                                                [isSelected]="false"
                                                [canClose]="true"
                                                (onDispatch)="onDispatchRoutes.emit($event)"
                                                (onEditResourceAllocation)="onEditResourceAllocation.emit($event)"
                                                (onClose)="onClose.emit()">
  </app-planning-draft-resources-table-list-item>

  <app-planning-draft-routes-table-list class="flex layout-column overflow-hidden"
                                        [routes]="sortedRoutes"
                                        [resources]="resources"
                                        [draft]="draft"
                                        [panel]="panel"
                                        [panels]="panels"
                                        [jobs]="jobs"
                                        [allJobs]="jobs"
                                        [selectedJobIds]="selectedJobIds"
                                        [visibleIds]="visibleRouteIds"
                                        [settings]="routesSettings"
                                        [itemElementSize]="itemElementSize"
                                        [dropListSortingDisabled]="false"
                                        [enableJobDropOnRow]="false"
                                        [dropListId]="panel.id"
                                        [emptyDropText]="'Add To Resource'"
                                        (onSelect)="onRouteSelect($event)"
                                        (onListDrop)="drop($event)"
                                        (onVisibleRoutesChange)="onVisibleRoutesChange.emit($event)"
                                        (onLockRouteChange)="onLockRouteChange.emit($event)"
                                        (onChangeRouteResource)="onChangeRouteResource.emit($event)"
                                        (onEditResourceAllocation)="onEditResourceAllocation.emit($event)"
                                        (onDispatch)="onDispatch.emit($event)"
                                        (onReoptimize)="onReoptimize.emit($event)"
                                        (onPrint)="onPrint.emit($event)"
                                        (onPrintLoadingSheet)="onPrintLoadingSheet.emit($event)"
                                        (onSettingsChange)="onRoutesSettingsChange.emit($event)"
                                        (onDelete)="onDelete.emit($event)">
  </app-planning-draft-routes-table-list>
</div>
